module.exports = __webpack_public_path__ + "static/after-chaos_2008-7fd0efb6fac55ed8c7fc508c872936c7.jpg";